import React, { useEffect, useState } from "react";
import "./RulerControls.css";

import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import PaletteIcon from "@mui/icons-material/Palette";
// import FormatPaintIcon from "@mui/icons-material/FormatPaint";
// import UndoOutlined from "@mui/icons-material/UndoOutlined";
// import RedoOutlined from "@mui/icons-material/RedoOutlined";
import IconButton from "@mui/material/IconButton";

import {
  GridOff,
  GridOn,
  RedoOutlined,
  UndoOutlined,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";

const RulerControls = () => {
  const [unit, setUnit] = useState("0.1");
  const [drawMode, setDrawMode] = useState("two");
  const [lineMode, setLineMode] = useState("orthogonal");
  const [tickCount, setTickCount] = useState(2);
  const [fontSize, setfontSize] = useState("1");
  const [rulerColor, setRulerColor] = useState("#ffffff");
  const [onGrid, setOnGrid] = useState(null);
  useEffect(() => {
    if (window.canvasEngine && window.canvasEngine.rulerHandler) {
      const ruler = window.canvasEngine.rulerHandler;
      ruler.unitScaleFactor = parseFloat(unit);
      ruler.rulerLineMode = lineMode;
      ruler.rulerUnitSymbol =
        //new conversion by rishabh

        ruler.rulerUnitSymbol =
          unit === "0.1" ? "nm" : unit === "0.0001" ? "µm" : null;

      window.canvasEngine.setRulerLineColor(rulerColor);
      window.canvasEngine.setRulerValues(tickCount);
    }
  }, [unit, lineMode, rulerColor, tickCount, onGrid]);

  return (
    <div className="ruler-controls">
      {/* new conversion rishabh */}
      <Tooltip title="Unit" placement="bottom">
        <span>
      <select
        value={unit}
        onChange={(e) => setUnit(e.target.value)}
      >
        <option value="0.1">Nanometers</option>
        <option value="0.0001">Micrometers</option>
      </select>
      </span>
      </Tooltip>

      {/* change for two and poly line mode  */}
      <Tooltip title="Mode" placement="bottom">
        <span>
      <select
        value={drawMode}
        onChange={(e) => {
          setDrawMode(e.target.value);
          if (e.target.value === "two") {
            window.canvasEngine.rulerHandler.polylineMode = false;
          } else {
            window.canvasEngine.rulerHandler.polylineMode = true;
          }
        }}
      >
        <option value="two">Two line Mode</option>
        <option value="poly">Bending mode</option>
      </select>
      </span>
      </Tooltip>

      {/* changes in select mode for ruler rishabh */}
      <Tooltip title="Direction" placement="bottom">
        <span>
      <select
        value={lineMode}
        onChange={(e) => {
          setLineMode(e.target.value);
          window.canvasEngine.rulerHandler.rulerLineMode = e.target.value;
        }}
      >
        <option value="orthogonal">Orthogonal</option>
        <option value="free">Free</option>
        <option value="diagonal">Diagonal</option>
        <option value="5">5 Degrees</option>
        <option value="10">10 Degrees</option>
        <option value="15">15 Degrees</option>
      </select>
      </span>
      </Tooltip>

      <Tooltip title="Pointers" placement="bottom">
        <span>
      <select
        value={tickCount}
        onChange={(e) => setTickCount(parseInt(e.target.value))}
      >
        {[...Array(10).keys()].map((i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1} Values
          </option>
        ))}
      </select>
      </span>
      </Tooltip>
      {/* Adjust font size of ruler distance  rishabh */}
      
      <Tooltip title="Font Size" placement="bottom">
        <span>
      <select
        value={fontSize}
        id="fontSize"
        onChange={(e) => {
          setfontSize(e.target.value);
          window.canvasEngine.rulerHandler.fontSize = parseFloat(
            e.target.value
          );
        }}
      >
        <option value="0.8">8</option>
        <option value="0.9">9</option>
        <option value="1">10</option>
        <option value="1.1">11</option>
        <option value="1.2">12</option>
        <option value="1.3">13</option>
        <option value="1.4">15</option>
        <option value="1.5">16</option>
        <option value="1.6">17</option>
        <option value="1.7">18</option>
      </select>
      </span>
      </Tooltip>

      {/* <button
        value={onGrid}
        onClick={() => {
          setOnGrid((prev) => !prev);
          if (onGrid) {
            window.canvasEngine.rulerHandler.rulerOnGrid = true;
          } else {
            window.canvasEngine.rulerHandler.rulerOnGrid = false;
          }
        }}
        // style={{
        //   alignItems: "center",
        //   justifyContent: "center",
        // }}
      >
        {onGrid ? (
          <Tooltip title="Off Grid" placement="bottom">
          <GridOff fontSize="small" />
          </Tooltip>
        ) : (
          <Tooltip title="On Grid" placement="bottom">
          <GridOn fontSize="small"/>
          </Tooltip>
        )}
      </button> */}
      <Tooltip title={onGrid ? "Off Grid" : "On Grid"} placement="bottom">
  <IconButton
    size="small"
    onClick={() => {
      setOnGrid((prev) => !prev);
      window.canvasEngine.rulerHandler.rulerOnGrid = !onGrid;
    }}
  >
    {onGrid ? (
      <GridOff fontSize="small" />
    ) : (
      <GridOn fontSize="small" />
    )}
  </IconButton>
</Tooltip>


     {/* Color Picker */}
<Tooltip title="Color Picker" placement="bottom">
  <IconButton size="small" component="label" sx={{
      color: "#fff",          // ✅ force white
    }}>
    <PaletteIcon fontSize="small" />
    <input
      type="color"
      hidden
      value={rulerColor}
      onChange={(e) => setRulerColor(e.target.value)}
    />
  </IconButton>
</Tooltip>

{/* Reset Rulers */}
<Tooltip title="Reset Rulers" placement="bottom">
  <IconButton
    size="small"
    onClick={() => {
      window.canvasEngine.rulerHandler.resetCurrentCellRulers();
      setRulerColor("#ffffff");
    }}
  >
    <FormatPaintIcon fontSize="small" />
  </IconButton>
</Tooltip>

{/* Undo Ruler */}
<Tooltip title="Undo Ruler" placement="bottom">
  <IconButton
    size="small"
    onClick={() => {
      window.canvasEngine.rulerHandler.undoRuler();
    }}
  >
    <UndoOutlined fontSize="small" />
  </IconButton>
</Tooltip>

{/* Redo Ruler */}
<Tooltip title="Redo Ruler" placement="bottom">
  <IconButton
    size="small"
    onClick={() => {
      window.canvasEngine.rulerHandler.redoRuler();
    }}
  >
    <RedoOutlined fontSize="small" />
  </IconButton>
</Tooltip>

    </div>
  );
};

export default RulerControls;
